import { render, staticRenderFns } from "./updateFields.vue?vue&type=template&id=67869936&"
import script from "./updateFields.vue?vue&type=script&lang=js&"
export * from "./updateFields.vue?vue&type=script&lang=js&"
import style0 from "./updateFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports